import { Injectable } from '@angular/core';
import { ApiRouteConstants } from '../../constants/api-routes';
import { HttpClient } from '@angular/common/http';
import { UserCreationFromContactRequest } from '../../../modules/user/shared/models/user-creation-from-contact-request';
import { Observable } from 'rxjs';
import { EmailVerificationStatus } from './models/email-verification-status';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private readonly userApiRoute = ApiRouteConstants.User;

    constructor(private readonly http: HttpClient) {}

    createFromContact(
        request: UserCreationFromContactRequest,
    ): Observable<void> {
        return this.http.post<void>(
            this.userApiRoute.createFromContact,
            request,
        );
    }

    getEmailVerificationStatus(
        userId: number,
    ): Observable<EmailVerificationStatus> {
        const fullRoute = this.userApiRoute.emailVerificationStatusUrl(userId);

        return this.http.get<EmailVerificationStatus>(fullRoute);
    }

    sendEmailVerificationEmail(userId: number): Observable<void> {
        const fullRoute =
            this.userApiRoute.sendEmailVerificationEmailUrl(userId);

        return this.http.post<void>(fullRoute, null);
    }
}
